import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const SendMessageButtonIcon = (props: SvgIconProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon width="21" height="22" viewBox="0 0 21 22" fill="none" {...props}>
    <g clipPath="url(#clip0_109_2)">
      <path
        // eslint-disable-next-line
        d="M5.48704 12.0791C6.4137 12.0791 7.3425 12.0791 8.2756 12.0791C8.95343 12.0791 9.41891 11.7319 9.40175 10.9859C9.38459 10.2399 8.94914 9.91149 8.24986 9.91853C6.42871 9.93495 4.60328 9.89507 2.78857 9.91853C1.88122 9.91853 1.46722 9.54787 1.31921 8.51098C1.02749 6.51929 0.587754 4.54638 0.214516 2.56408C0.126682 2.18436 0.066433 1.79765 0.0343323 1.40754C-0.0235839 0.161862 0.61564 -0.316705 1.64955 0.213473C4.03699 1.43335 6.41584 2.67199 8.7947 3.89891C11.6047 5.33695 14.4126 6.76092 17.2119 8.2107C18.1857 8.71507 19.1424 9.25698 20.0948 9.81062C21.2832 10.5144 21.3153 11.4997 20.0948 12.2316C18.722 13.0597 17.3062 13.7846 15.8776 14.5189C13.2993 15.8584 10.7252 17.2425 8.10829 18.4764C5.87958 19.5251 3.81819 20.9326 1.52943 21.8522C0.476212 22.2768 -0.165157 21.7677 0.0278972 20.5385C0.456906 18.0213 0.935252 15.5159 1.38786 13.0034C1.53586 12.187 2.16222 12.1565 2.69419 12.1167C3.6187 12.051 4.54965 12.0979 5.48275 12.0979L5.48704 12.0791Z"
        fill="currentColor"
        // fill="#4BB1E7"
      />
    </g>
    <defs>
      <clipPath>
        <rect width="21" height="22" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
)

export default SendMessageButtonIcon
